export const THEME_MODE_NATURE = 'nature' as const;
export const THEME_MODE_DARK = 'dark' as const;
export const THEME_MODE_LIGHT = 'light' as const;

export const AVAILABLE_THEME_MODES = [
  THEME_MODE_NATURE,
  THEME_MODE_DARK,
  THEME_MODE_LIGHT,
] as const;

export const DEFAULT_THEME_MODE = THEME_MODE_NATURE;
export const THEME_STORAGE_KEY = 'app-theme-mode';

export const BORDER_RADIUS = {
  small: '4px',
  medium: '6px',
  large: '12px',
} as const;

export const SCROLLBAR = {
  size: '4px',
  borderRadius: '2px',
  thumbColor: 'rgba(255, 255, 255, 0.08)',
  thumbColorHover: 'rgba(255, 255, 255, 0.12)',
  trackColor: 'transparent',
} as const;

export const MINIMAL_SCROLLBAR_SX = {
  '&::-webkit-scrollbar': {
    width: SCROLLBAR.size,
    height: SCROLLBAR.size,
  },
  '&::-webkit-scrollbar-track': {
    backgroundColor: SCROLLBAR.trackColor,
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: SCROLLBAR.thumbColor,
    borderRadius: SCROLLBAR.borderRadius,
    '&:hover': {
      backgroundColor: SCROLLBAR.thumbColorHover,
    },
  },
  scrollbarWidth: 'thin' as const,
  scrollbarColor: `${SCROLLBAR.thumbColor} ${SCROLLBAR.trackColor}`,
} as const;
